var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoffdocu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69302 14.3097C2.3703 14.3097 2.10777 14.0473 2.10777 13.7246V3.4258C2.10777 3.10319 2.3703 2.84066 2.69302 2.84066H3.65845V5.15202H9.51004V2.84066H10.4463C10.769 2.84066 11.0315 3.10319 11.0315 3.4258V9.9265L12.2018 8.62347V3.4258C12.2018 2.45786 11.4143 1.67027 10.4463 1.67027H8.23952C7.99805 0.98912 7.34722 0.5 6.58424 0.5C5.82138 0.5 5.17056 0.98912 4.92909 1.67027H2.69302C1.72497 1.67027 0.9375 2.45786 0.9375 3.4258V13.7246C0.9375 14.6926 1.72497 15.4801 2.69302 15.4801H7.45342L6.22398 14.3097H2.69302ZM5.99911 2.84066V2.25552C5.99911 1.9328 6.26164 1.67027 6.58424 1.67027C6.90697 1.67027 7.1695 1.9328 7.1695 2.25552V2.84066H8.33977V3.98175H4.82883V2.84066H5.99911ZM9.86115 7.49268H5.61882V6.3223H9.86115V7.49268ZM4.44843 6.3223V7.49268H3.27816V6.3223H4.44843ZM5.648 9.83334V8.66296H9.86115V9.83334H5.648ZM4.47773 9.83334H3.27816V8.66296H4.47773V9.83334ZM3.27816 11.0036H4.44843V12.1739H3.27816V11.0036ZM14.0416 10.078L9.17175 15.5L6.00529 12.4859L6.81221 11.6382L9.10606 13.8217L13.1709 9.29593L14.0416 10.078Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoffdocu);
export default __webpack_public_path__ + "static/media/signoffdocu.89a22f8b174d8ec96cc27679981dae56.svg";
export { ForwardRef as ReactComponent };